import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {
  
  const imageToggles = node.querySelectorAll('.js-mm-item')

  for (var imageToggle of imageToggles) {
      jQuery(imageToggle).hover(function() {
        jQuery('.js-mm-image').removeClass('show');
        jQuery('#' + jQuery(this).data('item')).addClass('show');
      });
  }

    const close = node.querySelector('.js-toggle--close');

    
  
  
  const extra_toggles = node.querySelectorAll('.js-toggle-extra');
  
  for (const extra_toggle of extra_toggles) {
    extra_toggle.addEventListener('click', () => {
      extra_toggle.classList.toggle('open')

      let id = extra_toggle.dataset.id;
      $(node.querySelector(`.js-extra[data-id="${id}"]`)).slideToggle();

      if ($('.js-extra-slider').hasClass('slick-initialized')) {

      } else {
        $('.js-extra-slider').slick({
          arrows: false,
          dots: false,
          slidesToShow: 2,
          infinite: false
        })
      }
    })
  }



  jQuery(close).click(function() {
    jQuery(node).removeClass('mm--open');
    jQuery('.js-mm-image').removeClass('show');
    setTimeout(() => jQuery(node).fadeOut(), 100);
  });



  jQuery('.js-mm-cover').click(function() {
      jQuery(node).removeClass('mm--open');
      jQuery('.js-mm-image').removeClass('show');
      setTimeout(() => jQuery(node).fadeOut(), 100);
  });
  
  
})
